<template>
  <Modal
    width="920"
    title="建转化"
    v-model="state"
    class-name="vertical-center-modal"
    :mask-closable="false"
    @on-visible-change="bindGetData"
  >
    <Spin size="large" fix v-if="!loading"></Spin>
    <div class="c-steps">
      <Steps :current="current">
        <Step v-for="(item, index) in stepContents" :key="index" :title="setpTitle(index)" :content="item"></Step>
      </Steps>
    </div>

    <!-- 转化 -->
    <template v-if="current === 1">
      <div class="c-convert-margin">
        <Row :gutter="20" class="row-item">
          <Col span="8" class="col-item">
            <span>转化名称：</span>
          </Col>
          <Col span="10">
            <Select v-model="appTransId" label-in-value>
              <Option v-for="(item, id) in converts" :value="item.appTransId" :key="id">{{ item.transName }}</Option>
            </Select>
          </Col>
          <Col span="6">
            <Button type="primary" @click="$emit('on-refresh')" :loading="!loading">
              <span v-if="loading">刷新</span>
              <span v-else>刷新中...</span>
            </Button>
          </Col>
        </Row>
      </div>
      <!-- 爬虫挂了 -->
      <div v-if="!spiderWork" class="c-convert-margin">
        <Row :gutter="20" class="row-item">
          <Col span="8" class="col-item col-table">
            <div class="col-cell">
              <span><Icon size="48" color="#ed4014" type="md-close-circle" /></span>
            </div>
          </Col>
          <Col span="14" class="col-table">
            <div class="col-cell">
              <span class="c-convert-title c-convert-error"
                >检测到同步任务失效，无法自动化创建转化，请重新检测或者前往“同步任务页面”重新联调！</span
              >
            </div>
          </Col>
        </Row>
        <Row :gutter="20" class="row-item">
          <Col span="8" class="col-item">
            <span>&nbsp;</span>
          </Col>
          <Col span="8" style="text-align: center">
            <Button type="primary" :loading="!loading" @click="preCheckConvert">重新检测</Button>
          </Col>
        </Row>
      </div>
      <!-- 爬虫没有挂 -->
      <div v-else-if="convertState" class="c-convert-margin">
        <Row :gutter="20" class="row-item">
          <Col span="8" class="col-item col-table">
            <div class="col-cell">
              <span><Icon size="48" color="#19be6b" type="md-checkmark-circle-outline" /></span>
            </div>
          </Col>
          <Col span="14" class="col-table">
            <div class="col-cell">
              <span class="c-convert-title">我们会通过自动化服务建立转化，赶紧下一步吧！</span>
            </div>
          </Col>
        </Row>
      </div>
      <!-- 没有首次转化 -->
      <div v-else class="c-convert-form c-convert-margin">
        <Row v-if="!complete" :gutter="20" class="row-item">
          <Col span="8" class="col-item col-table">
            <div class="col-cell">
              <span><Icon size="48" color="#ff9900" type="md-information-circle" /></span>
            </div>
          </Col>
          <Col span="10" class="col-table">
            <div class="col-cell">
              <span class="c-convert-title c-convert-error">没有激活的转化，请用下面的信息进行首次联调</span>
            </div>
          </Col>
        </Row>
        <!-- 显示计划信息 -->
        <Row :gutter="20" class="row-item">
          <Col span="8" class="col-item">
            <span>计划名：</span>
          </Col>
          <Col span="10" class="col-no-warp">
            <span>{{ info.plan_name }}</span>
          </Col>
          <Col span="6">
            <Button type="default" v-clipboard:copy="info.plan_name" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</Button>
          </Col>
        </Row>
        <Row v-if="info.ch_platform_id === 2" :gutter="20" class="row-item">
          <Col span="8" class="col-item">
            <span>ITunesID：</span>
          </Col>
          <Col span="10" class="col-no-warp">
            <span>{{ appId }}</span>
          </Col>
          <Col span="6">
            <Button type="default" v-clipboard:copy="appId" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</Button>
          </Col>
        </Row>
        <Row v-if="info.ch_platform_id === 1" :gutter="20" class="row-item">
          <Col span="8" class="col-item">
            <span>应用包名：</span>
          </Col>
          <Col span="10" class="col-no-warp">
            <span>{{ info.ad_package }}</span>
          </Col>
          <Col span="6">
            <Button type="default" v-clipboard:copy="info.ad_package" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</Button>
          </Col>
        </Row>
        <Row v-if="info.ch_platform_id === 1" :gutter="20" class="row-item">
          <Col span="8" class="col-item">
            <span>游戏地址：</span>
          </Col>
          <Col span="10" class="col-no-warp">
            <span>{{ info.game_pack_addr }}</span>
          </Col>
          <Col span="6">
            <Button type="default" v-clipboard:copy="info.game_pack_addr" v-clipboard:success="onCopy" v-clipboard:error="onError"
              >复制</Button
            >
          </Col>
        </Row>
        <Row :gutter="20" class="row-item">
          <Col span="8" class="col-item">
            <span>追踪短链：</span>
          </Col>
          <Col span="10" class="col-no-warp">
            <span>{{ info.track_chain_addr }}</span>
          </Col>
          <Col span="6">
            <Button type="default" v-clipboard:copy="info.track_chain_addr" v-clipboard:success="onCopy" v-clipboard:error="onError"
              >复制</Button
            >
          </Col>
        </Row>
        <Row :gutter="20" class="row-item">
          <Col span="8" class="col-item">
            <span>联调IDFA/IMEI：</span>
          </Col>
          <Col span="10">
            <Input v-model="device_no" placeholder=""></Input>
          </Col>
          <Col span="6">
            <Button type="primary" :disabled="!Boolean(device_no)" @click="testIdfa">确定联调</Button>
          </Col>
        </Row>
        <!-- <Row :gutter="20" class="row-item">
          <Col span="8" class="col-item">
            <span>转化检测：</span>
          </Col>
          <Col span="10">
            <template v-if="complete">
              <span style="padding: 0 12px; color: green"><Icon type="ios-checkmark-circle" size="24" color="green" />已成功</span>
              <span style="color: green">可以通过接口自动化建立</span>
            </template>
            <template v-else>
              <Button type="primary" :loading="checking" @click="preCheck">点击验证</Button>
              <span v-if="checkFail" style="color: red">暂未收到成功转化，请稍后重试</span>
            </template>
          </Col>
        </Row> -->
      </div>
    </template>
    <!-- 转化结果 -->
    <template v-else-if="current === 2">
      <result title="创建结果" :columns="success_h" :data="success_d"></result>
    </template>

    <template slot="footer">
      <div v-if="current === 1" class="c-convert-footer">
        <Button type="primary" :loading="saving" :disabled="!spiderWork" @click="next">
          <span v-if="saving">提交中...</span>
          <span v-else>确认并下一步</span>
        </Button>
      </div>
      <div v-else-if="current === 2" class="c-convert-footer">
        <Button type="primary" @click="current = 1" v-if="btnRetry">返回上一步</Button>
        <Button type="default" @click="retry" v-if="btnRetry">重试</Button>
        <Button type="primary" @click="jump" v-if="btnSuccess">保存并新建创意</Button>
        <Button type="default" @click="close">完成并关闭</Button>
      </div>
    </template>
  </Modal>
</template>
<script>
import { isArray } from '@/common/js/utils'
import { connectTest } from '@/api/toutiao.model'
import { creatAdgroup } from '@/api/baidu.model'
import Result from './result.vue'
import mixin from '../../mixin'
export default {
  name: 'converter',
  mixins: [mixin],
  components: { Result },
  props: {
    value: {
      type: Boolean
    },
    info: {
      type: Object,
      default() {
        return {}
      }
    },
    loading: {
      type: Boolean
    },
    campaign: {
      type: [Number, String]
    },
    converts: {
      type: Array
    },
    type: {
      type: Number
    },
    account: {
      type: [Number, String]
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    appId() {
      let appid = 0
      if (this.info && this.info.ch_platform_id && this.info.convert_check_url) {
        appid = parseInt(this.getAppId(this.info.convert_check_url))
      }
      return appid
    },
    setpTitle() {
      return (index) => {
        let txt = '进行中'
        if (index !== this.current) txt = index < this.current ? '已完成' : '未完成'
        return txt
      }
    }
  },
  watch: {
    'info.success_cnt'(nVal) {
      if (typeof nVal === 'number') this.stepContents[0] = `草花内部计划（成功${nVal}条）`
    }
  },
  methods: {
    bindGetData(val) {
      if (val) {
        // 还原默认值
        this.checking = false
        this.saving = false
        this.current = 1
        this.device_no = ''

        // this.spiderWork = false
        this.appTransId = ''
        this.checkFail = false
        this.btnSuccess = false
        this.btnRetry = false
        this.success_d = []

        this.preCheckConvert()
      }
    },
    onCopy() {
      this.$Message.success('复制成功！')
    },
    onError() {
      this.$Message.warning('剪切板禁止访问')
    },
    retry() {
      this.success_d = []
      this.next()
    },
    close() {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>关闭当前页面，后面的批量建创意将会被打断，是否确定？</p>',
        onOk: () => {
          this.$Message.info({
            content: '页面将 2 秒后自动关闭',
            duration: 2,
            onClose: () => {
              window.close()
            }
          })
        }
      })
    },
    jump() {
      if (this.ad_id && this.req_id) {
        this.jumpToIdea(
          {
            id: this.campaign,
            ad: this.ad_id
          },
          {
            req: this.req_id,
            plan: this.plan_id
          }
        )
      } else this.$Message.warning('计划未创建成功，无法跳转')
    },
    testIdfa() {
      connectTest({
        id: this.info.plan_id,
        device_no: this.device_no
      }).then((data) => {
        if (data) {
          this.$Message.success('联调成功！')
        }
      })
    },
    next() {
      this.createPlan()
    },
    createPlan() {
      const param = {
        ad_account_id: this.account,
        req_id: this.info.req_id,
        appTransId: this.appTransId
      }

      this.saving = true
      this.$emit('on-loading', false)
      creatAdgroup(param).then((data) => {
        this.saving = false
        this.$emit('on-loading', true)
        if (data && isArray(data)) {
          this.success_d = data
          this.current = 2
          // 成功状态
          this.btnSuccess = this.success_d.some((ret) => ret.ad_id)
          this.btnRetry = this.success_d.some((ret) => !ret.ad_id)
          // 所有成功的组
          const listSuccess = this.success_d.filter((ret) => ret.ad_id)
          if (listSuccess.length) {
            this.ad_id = listSuccess[0].ad_id
            this.req_id = listSuccess[0].req_id
            this.plan_id = listSuccess[0].plan_id
          }
        }
      })
    },
    // preCheck () { 暂时爬虫脚本不通
    //   const platform = this.info.ch_platform_id
    //   const account = this.$store.state.Baidu.account
    //   let param = { ad_account_id: account, platform }
    //   if (platform === 1) param = Object.assign(param, {packageName: this.info.ad_package})
    //   else if (platform === 2) param = Object.assign(param, {appId: this.appId})
    //   this.checking = true
    //   checkConvert(param).then(check => {
    //     this.checking = false
    //     this.checkFail = !check
    //     this.complete = !!check
    //   })
    // },
    preCheckConvert() {
      // let platform = this.info.ch_platform_id
      // let account = this.$store.state.Baidu.account
      // let param = { ad_account_id: account, platform }
      // const param2 = { ad_account_id: parseInt(account) }
      // if (platform === 1) param = Object.assign(param, {packageName: this.info.ad_package})
      // else if (platform === 2) param = Object.assign(param, {appId: this.appId})

      // this.loading = false
      // Promise.all([checkConvert(param), isSpiderWork(param2)]).then(data => {
      //   this.loading = true
      //   const [check, iswork] = data
      //   this.convertState = !!check
      //   this.complete = !!check
      //   this.spiderWork = !!iswork
      // })
      // 强制逻辑
      this.convertState = false // 转化状态
      this.complete = true // 转化是没有首次联调
      this.spiderWork = true // 爬虫成功
    }
  },
  data() {
    return {
      checking: null,
      saving: null,
      current: 1, // 当前步骤
      stepContents: [], // 步骤信息

      spiderWork: null, // 爬虫状态
      complete: null, // 是否首次联调
      checkFail: null, // 转化失败
      convertState: null, // 待转化

      device_no: '', // 联调
      appTransId: '',

      btnSuccess: null, // 成功状态
      btnRetry: null, // 失败状态
      success_h: [
        {
          key: 'campaign_name',
          title: '推广计划'
        },
        {
          key: 'plan_name',
          title: '推广单元'
        },
        {
          key: 'inner_status',
          title: '内部计划'
        },
        {
          key: 'convert_status',
          title: '转化'
        },
        {
          key: 'outer_status',
          title: '结果',
          render: (h, params) => {
            const { ad_id, outer_status, remark } = params.row
            const msg = ad_id ? outer_status : `${outer_status}, ${remark}`
            return h('span', msg)
          }
        }
      ],
      success_d: []
    }
  },
  created() {
    this.stepContents.push(...['草花内部计划（成功0条）', '百度转化/选择', '百度推广单元'])
  }
}
</script>
<style lang='scss' scoped>
.c-steps {
  width: 800px;
  margin: 12px -50px 0 auto;
}

/* 表单部分 */
.c-convert-margin {
  margin-top: 20px;

  .col-table {
    height: 80px;
    display: inline-table;
  }

  .col-cell {
    display: table-cell;
    vertical-align: middle;
  }

  .c-convert-title {
    font-size: 14px;

    &.c-convert-error {
      color: #ed4014;
    }
  }
}

.row-item {
  align-items: flex-start;
  font-size: 14px;
  margin-bottom: 18px;
}

.col-item {
  font-weight: bold;
  line-height: 32px;
}

.col-no-warp {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  line-height: 32px;
}

/* 自定义脚本 */
.c-convert-footer {
  padding: 0 12px;
  text-align: center;
}
</style>
